import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class PartnerAvailability extends BaseAPIModel {
    // Allow us to call getAll directly
    static list(item) {
        return this.fromJSON(item);
    }

    static listUrl({ organizationId, partnerId, zoneId = null }) {
        if (!organizationId || !partnerId) {
            throw new ArgumentError(`[Model][PartnerAvailability][getAll] organizationId and partnerId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/partners/${partnerId}/zones${zoneId ? '/' + zoneId : ''}`;
    }
}
